<div class="app-container">
  <div class="top-bar">
    <div class="header-content">
      <div class="bar-left-content">
        @if (taxonomyService.taxoCheckFlag() === "taxonomy-dashboard-subpage") {
        <img class="back-icon" src="assets/icons/arrow_back_header.svg" alt="back-icon" (click)="handleBackPress()">
        }
        <div class="title">
          {{config.title}}
        </div>

        <!-- Taxonomy Dashboard menu -->
        @if (taxonomyService.taxoCheckFlag() === "taxonomy-dashboard-subpage") {
        <app-taxonomy-list></app-taxonomy-list>
        }
      </div>

      <div class="bar-right-content">
        <div class="taxonomy-action-btn">
          @if (taxonomyService.taxoCheckFlag() === "taxonomy-dashboard-subpage") {
          <app-taxonomy-actions></app-taxonomy-actions>
          }
        </div>

        <!--  taxonomy-version-actions -->
        <div class="taxonomy-action-btn">
          @if (taxonomyService.taxoCheckFlag() === "taxonomy-dashboard-subpage") {
          <app-taxonomy-version-actions></app-taxonomy-version-actions>
          }
        </div>

        <div class="menu-icon">
          <div class="icon">
            <div class="profile-icon-wrapper" (click)="toggleDropdown()">
              <img src="assets/icons/profile-icon.svg" alt="icon3" class="profile-icon" />
              @if (showDropdown) {
              <div class="dropdown" (click)="toggleDropdown()" appOutSideClick (outSideClick)="onOutsideClick()"
                (outSideClick_v2)="toggleDropdown()">
                <li (click)="clickLogout() "><img src="assets/icons/save_alt.svg" alt="logout icon"
                    class="logout-icon" />Log Out</li>
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tab Wrapper - Show only for main taxonomy dashboard routes -->
    @if (showTabWrapper) {
    <div class="tab-wrapper">
      <div class="tab-selection">
        <div class="tab-buttons">
          <button [class.active]="selectedTabIndex === 0" (click)="onTabChange(0)">
            All Taxonomies
          </button>
          <button [class.active]="selectedTabIndex === 1" (click)="onTabChange(1)">
            Playground
          </button>
        </div>
      </div>
    </div>
    }
  </div>
</div>
